import axios from 'axios'

// const apiUrl = 'http://localhost:3000/api/graph-api'
// const apiUrl = 'https://api.jobizo.dc1.codalien.net/api/graph-api'
const apiUrl = 'https://app.jobizo.com/api/graph-api'
// const apiUrl = 'https://app.jobizo.com/api/graph-api'

const resolve = responseData => {
  const resultant = {}
  if (responseData.errors) {
    resultant.error = {
      errors: [...responseData.errors]
    }
  } else resultant.error = responseData.error || null
  resultant.data = responseData.data || null
  return resultant
}

const api = async (query, variables = null) => {
  const data = {
    query: query
  }
  if (variables) {
    data.variables = variables
  }
  let resultant = {}
  try {
    const { data: response } = await axios({
      method: 'POST',
      url: apiUrl,
      data: data
    })
    resultant = resolve(response)
  } catch (err) {
    console.log('api error', err)
    if (err.response) {
      const { data: response } = err.response
      resultant = resolve(response)
    } else {
      resultant = { error: err.message, data: undefined }
    }
  }

  return resultant
}

// api.BUILD_FLAVOUR = BUILD_FLAVOUR

export default api
